export const selectVariantWithFallback = (variants, selectedOptions) => {
  const exactVariant = variants.find(({ options }) =>
    options.every((option, index) => selectedOptions[index] === option),
  )
  const variant =
    exactVariant ||
    variants.find(candidate => candidate.option1 === selectedOptions[0])

  return {
    variant,
    selectedOptions: variant ? [...variant.options] : [...selectedOptions],
    usedFallback: !exactVariant && Boolean(variant),
  }
}

export const getOptionState = (value, availableVariants, allVariants) => {
  const available = availableVariants.some(variant => variant.includes(value))
  const exists = allVariants.some(variant => variant.includes(value))

  return {
    disabled: !available,
    outOfStock: exists && !available,
    noExist: !exists,
  }
}

export const buildVariantLabelAria = (optionName, labelText, isSelected) =>
  optionName && labelText
    ? `${optionName} ${labelText}${isSelected ? ', selected' : ''}`
    : null

export const isVariantActivationKey = event =>
  event.key === 'Enter' || event.code === 'Space' || event.key === ' '
